import { gql } from '@apollo/client'
import { sortReplies } from '@btime/helpers'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useServiceOrderState = () => React.useContext(Context)
export const useServiceOrder = () => useServiceOrderState()?.serviceOrder
export const useReplies = () => {
  const replies = useServiceOrder()?.replies || []
  return sortReplies(replies)
}

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      documents {
        id
        src
        type
        description
      }
      statusReason {
        id
        typeId
        name
        description
        document {
          id
          src
        }
      }
      events {
        id
        status {
          id
          name
        }
        eventDate
        address
        reason {
          id
          name
        }
        document {
          id
          type
          src
        }
        description
      }
      status {
        id
        name
      }
      user {
        id
        name
        fieldValues {
          id
          value
          field {
            id
            name
          }
        }
      }
      placeId
      place {
        id
        name
        resume
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      company {
        id
        name
        nationalRegistration
      }
      checklist {
        id
        name
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          parentReference
          reference
          ordination
          categoryOrdination
          nonComplianceConditions
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, id }) => {
  const permalinkToken = usePermalinkToken()

  const { data, ...state } = useQuery(QUERY, {
    variables: { id, permalinkToken: permalinkToken },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ServiceOrdersLoader
